'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
require('../../DataDisplays/Avatar/Avatar.js');
var CountBadge = require('../../DataDisplays/CountBadge/CountBadge.js');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Label/Label.js');
var SystemIcon = require('../../DataDisplays/SystemIcon/SystemIcon.js');
require('react');
require('@wishket/yogokit');
require('../../../_virtual/_tslib.js');
require('../../Inputs/AutoCompleteList/AutoCompleteList.parts.js');
require('../../Inputs/Input/Input.js');
require('../../Inputs/Input/PasswordInput.js');
require('../../Inputs/Input/LableInput.js');
require('../../Inputs/Input/InputTypeSelector.js');
require('../../Inputs/Calendar/Calendar.utils.js');
require('../../Inputs/Checkbox/Checkbox.js');
require('../../Inputs/ChoiceChip/ChoiceChip.js');
var IconButton = require('../../Inputs/IconButton/IconButton.js');
require('../../Inputs/Radio/Radio.js');
require('../../Inputs/TextField/TextField.js');
require('../../Inputs/CommentArea/CommentArea.js');
var IconButtonDropdown = require('../../Inputs/IconButtonDropdown/IconButtonDropdown.js');
require('../../Inputs/MultiColumnList/MultiColumnList.parts.js');
require('../../Inputs/FilterChip/FilterChip.js');

/**
 * 메뉴 컴포넌트는 네비게이션에서 사용되는 클릭 가능한 항목을 표시합니다.
 *
 * @param {Object} props
 * @param {'main' | 'sub'} [props.type='main'] - 메뉴 타입 ('main', 'sub')
 * @param {'white' | 'gray'} [props.variant='white'] - 메뉴 스타일 변형 ('white', 'gray')
 * @param {string} props.name - 메뉴에 표시될 텍스트
 * @param {string} [props.badgeCount] - 메뉴 항목에 표시될 뱃지 숫자
 * @param {boolean} [props.isSelected=false] - 메뉴 선택 상태
 * @param {SystemIconName} [props.leadingIcon] - 메뉴 앞쪽에 표시될 아이콘(medium 사이즈)
 * @param {SystemIconName} [props.iconButtonName] - IconButtonDropdown 아이콘(small 사이즈)
 * @param {() => void} props.onClick - 메뉴 클릭 시 실행될 함수
 * @param {() => void} [props.onOptionClick] - 후행 아이콘 클릭 시 실행될 함수 (IconButtonDropdown이 아닌 IconButton으로만 사용 시 필요)
 * @param {ReactNode} [props.children] - 메뉴 내부에 표시될 자식 요소 (IconButtonDropdown 컴포넌트 사용 시 필요, trailingIcon과 함께 사용하지 않도록 주의 필요)
 * @param {Item[]} [props.items] - IconButtonDropdown 컴포넌트 사용 시 필요 {key: number, value: string}[]
 * @param {Item} [props.selectedItem] - IconButtonDropdown 컴포넌트 사용 시 필요 {key: number, value: string}
 * @param {(item: Item) => void} [props.onItemClick] - IconButtonDropdown 컴포넌트 사용 시 필요 (item: Item) => {}
 *
 * @example
 * // 기본 메뉴
 * <Menu
 *   name="메뉴 항목"
 *   onClick={() => console.log('메뉴 클릭')}
 * />
 *
 * // 아이콘과 뱃지가 있는 서브 메뉴
 * <Menu
 *   type="sub"
 *   name="서브 메뉴"
 *   leadingIcon="home"
 *   badgeCount="5"
 *   onClick={() => console.log('서브 메뉴 클릭')}
 * />
 *
 * // IconButtonDropdown과 함께 사용시
 * <Menu
 *   name="메뉴"
 *   onClick={() => console.log('메뉴 클릭')}
 *   iconButtonName="small_more_options"
 *   items={items}
 *   selectedItem={selectedItem}
 *   onItemClick={onItemClick}
 * />
 *
 * // 드롭다운이 필요하지 않은 옵션 메뉴(ex. 버튼 클릭 시 모달 오픈))
 * <Menu
 *   variant="gray"
 *   name="옵션 메뉴"
 *   isSelected={true}
 *   iconButtonName="small_more_options"
 *   onClick={() => console.log('메뉴 클릭')}
 *   onOptionClick={() => console.log('옵션 클릭', '모달 오픈')}
 * />
 */ const Menu = ({ type = 'main', variant = 'white', name, isSelected = false, badgeCount, leadingIcon, iconButtonName, onClick, onOptionClick, items, selectedItem, onItemClick })=>{
    const needIconButtonDropdown = !!iconButtonName && !!items && !!onItemClick && !!selectedItem;
    const needTrailingIcon = !!iconButtonName && !!onOptionClick;
    const getMenuClassNames = (type, variant, isSelected)=>{
        const baseClasses = 'flex w-full cursor-pointer items-center gap-2 rounded-xl px-4 py-3 text-w-gray-900';
        const typeClasses = type === 'sub' ? 'pl-12' : '';
        const variantClasses = {
            white: tailwindMerge.twJoin('bg-w-white hover:bg-w-gray-50', isSelected && 'bg-primary-10 text-primary hover:bg-primary-10'),
            gray: tailwindMerge.twJoin('bg-w-gray-50 hover:bg-w-gray-100', isSelected && 'bg-w-gray-100  hover:bg-w-gray-100')
        };
        return tailwindMerge.twMerge(baseClasses, typeClasses, variantClasses[variant]);
    };
    const getCountBadgeVariant = (variant, isSelected)=>{
        if (variant !== 'white') return 'white_gray';
        return isSelected ? 'primary' : 'gray';
    };
    return jsxRuntime.jsxs(Box, {
        "data-testid": "design-system-menu",
        className: getMenuClassNames(type, variant, isSelected),
        onClick: onClick,
        children: [
            leadingIcon && jsxRuntime.jsx(SystemIcon, {
                testId: "design-system-menu-leading-icon",
                name: leadingIcon,
                className: tailwindMerge.twJoin(variant === 'white' && isSelected && 'text-primary')
            }),
            jsxRuntime.jsx(Typography, {
                "data-testid": "design-system-menu-name",
                variant: "body1",
                className: "w-full select-none",
                children: name
            }),
            badgeCount && jsxRuntime.jsx(CountBadge, {
                variant: getCountBadgeVariant(variant, isSelected),
                text: badgeCount,
                className: "relative",
                showZero: true
            }),
            needIconButtonDropdown && jsxRuntime.jsx(IconButtonDropdown, {
                size: "sm",
                icon: iconButtonName,
                items: items,
                selectedItem: selectedItem,
                onItemClick: onItemClick
            }),
            needTrailingIcon && jsxRuntime.jsx(IconButton, {
                size: "sm",
                className: "shrink-0",
                onClick: (e)=>{
                    e.stopPropagation();
                    onOptionClick();
                },
                children: jsxRuntime.jsx(SystemIcon, {
                    name: iconButtonName
                })
            })
        ]
    });
};

module.exports = Menu;
